import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import PropTypes from "prop-types";
import {ReactComponent as CalendarIcon} from '../customDateRangePicker/Calendar.svg';
import {ReactComponent as ChevronDownIcon} from '../customDateRangePicker/ChevronDown.svg';
import Button from '../button/Button';
import styles from './CustomSingleDatePicker.module.scss';


const CustomInput = forwardRef(
  ({ value, onClick }, ref) => (
    <div ref={ref}>
      <Button
        variant="primary-light"
        size="small"
        onClick={onClick}
        label={
          <div className={styles.dateLabel}>
            <CalendarIcon />
            <span>{value}</span>
            <ChevronDownIcon />
          </div>
        }
      />
    </div>
  ),
);

CustomInput.displayName = "CustomInput"

CustomInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func
}

const CustomSingleDatePicker = ({
  date,
  onChange,
  minDate,
  maxDate,
}) => {
  return (
    <div>
      <DatePicker
        selected={date}
        onChange={(date) => onChange(date)}
        customInput={<CustomInput />}
        minDate={minDate}
        maxDate={maxDate}
      />
    </div>
  );
};

CustomSingleDatePicker.propTypes = {
  date: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
}

export default CustomSingleDatePicker;
